<script type="application/ld+json">
	{     
		"@context": "http://schema.org",
		"@type": "BreadcrumbList",
		"itemListElement": [
		{
		  "@type": "ListItem",
		  "position": 1,
		  "item": {
		    "@id": "https://www.protectt.ai/",
		    "name": "Home"
		  }
		},{
		  "@type": "ListItem",
		  "position": 2,
		  "item": {
		    "@id": "https://www.protectt.ai/platform",
		    "name": "Platform"
		  }
		}		]
	}
	</script>
<!-- Breadcrumbs -->
<div class="breadcrumbs">
  <div class="container">
    <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <ul class="breadcrumbsul">
          <li><a href="#">Home</a></li>
          <li>></li>
          <li>Platform</li>
        </ul>
      </div>
    </div>
  </div>
</div>
<!-- Start Introduction -->
<div
  style="background: linear-gradient(0deg, rgba(0, 0, 0, 0.0), rgba(0, 0, 0, 0.0)),url('assets/images/header/header-1.webp'); background-position: right; background-size: cover;"
  class="section-agency-benefit section-pt section-pb-60 d-none d-md-block" (window:resize)="onResize($event)">
  <div class="container subbanner">
    <div class="row align-items-center">
      <div class="col-lg-8 col-md-8 col-xl-8">
        <div class="d-none d-sm-block" *ngIf="innerWidth > 768">
          <h1 id="bnr-heading">{{heading}}</h1>
        </div>
      </div>
    </div>
  </div>
</div>


<!-- Banner For Mobile -->

<div
  style="background: linear-gradient(0deg, rgba(0, 0, 0, 0.0), rgba(0, 0, 0, 0.0)),url('assets/images/header/header-mobile.webp'); background-position: top; background-size: cover;"
  class="section-agency-benefit section-pt section-pb-60 d-block d-md-none">
  <div class="container subbanner">
    <div class="row align-items-center">
      <div class="col-lg-12">
        <div class="mt-50">
          <!-- header background -->
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Banner Heading For Mobile -->

<div class="container d-block d-md-none" (window:resize)="onResize($event)">
  <div class="row">
    <div class="col-12">
      <div class="mt-15 mb-15 text-center" *ngIf="innerWidth <= 768">
        <h1 id="bnr-heading">{{heading}}</h1>
        <h4 id="bnr-subheading">{{subheading}}</h4>
      </div>
    </div>
  </div>
</div>

<!-- End Introduction -->
<div style="background: #F4F4F4" class="section-service section-pt section-pb-60">
  <div class="container">
    <div class="row">
      <div class="col-lg-12">
        <div class="section-title text-center">
          <span style="color: #da2b27;">Extended Detection and Response (XDR) Platform</span>
          <h2>End to end Mobile App Security</h2>
        </div>
      </div>
    </div>
    <div class="thumb col-md-12 text-center">
      <img width="80%" src="assets/images/home/Platform_ArchitectureFigure1.webp" class="og_image_url"
        alt="Features of the Mobile App Security">
      <h6 class="mt-2">Predict, Prompt and Prevent from the cyber attacks in real time</h6>
    </div>
  </div>
</div>

<!-- Start Agency Benefits Area -->
<div class="section-agency-benefit section-ptb-30">
  <div class="container ">
    <div class="row align-items-center">
      <div class="agency-benefits col-md-8  ">
        <div class="content">
          <div class="section-title text-center">
            <h2>Prevent</h2>
          </div>
          <h6 class="text-justify">Our expertise in the domain of cyber science helped creating a best in class
            prevention mechanism. Two of our mobile end point offerings AppProtectt and MProtectt prevents most of the
            known cyber attacks on the mobile devices of your stake holders and customers. Protectt.ai services guides
            your organization to follow the best cyber practices to set up the standard across organization and leaves
            no stones unturned in terms of cyber security.</h6>
        </div>
      </div>
      <div class="agency-benefits col-md-4">
        <div class="content">
          <h3 class="custom-list  "><a routerLink="/mprotectt">MProtectt B2C</a></h3>
          <h3 class="custom-list  "><a routerLink="/mprotectt-biz-plus">MProtectt B2B</a></h3>
          <h3 class="custom-list  "><a routerLink="/appprotectt">AppProtectt</a></h3>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- End Agency Benefits Area -->

<!-- Start Agency Benefits Area -->
<div class="section-agency-benefit section-ptb-30">
  <div class="container">
    <div class="row align-items-center">
      <div class="agency-benefits col-md-8  ">
        <div class="content">
          <div class="section-title text-center">
            <h2>Predict</h2>
          </div>
          <h6>RealTime Protectt is one of our state of the art Fraud and Risk Management Engine powered by artificial
            intelligence and machine learning. Financial institutions redirects all the Fincritical instructions to us
            to analyze and compute the risk score that will be the decider to proceed further and terminate and flag the
            potential risk.</h6>
        </div>
      </div>
      <div class="agency-benefits col-md-4">
        <div class="content">
          <h3 class="custom-list  "><a routerLink="/realtime-protectt">RealTime Protectt</a></h3>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- End Agency Benefits Area -->

<!-- Start Agency Benefits Area -->
<div class="section-agency-benefit section-ptb-30">
  <div class="container">
    <div class="row align-items-center">
      <div class="agency-benefits col-md-8  ">
        <div class="content">
          <div class="section-title text-center">
            <h2>Prompt</h2>
          </div>
          <h6>Protectt.ai offers end-to-end security solutions from the pool of experienced Cyber
            Security Consultants who have deep domain and industry expertise. Our approach helps
            the customer to have a secured environment. It prompts through various parameters
            such as:</h6>
          <ul style="list-style: inside;">
            <li>Integrated threat detection and response</li>
            <li>An analytics-driven framework to contextualize</li>
            <li>Tighter integration between data, processes and products with real-time
              visibility</li>
            <li>Cost reduction in incident response and compliance</li>
          </ul>
        </div>
      </div>
      <div class="agency-benefits col-md-4">
        <div class="content">
          <!-- <h3 class="custom-list  "><a routerLink="/realtime-protectt">Real Time Protectt</a></h3> -->
          <h3 class="custom-list  "><a routerLink="/cyber-lab-services">Managed security services</a></h3>
          <h3 class="custom-list  "><a routerLink="/cyber-lab-services">Assessment service</a></h3>
          <h3 class="custom-list  "><a routerLink="/cyber-lab-services">Advisory & Compliance Management</a></h3>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- End Agency Benefits Area -->